import React, { Component } from 'react';
import * as api from '../../services/api';
import './index.scss';
import urlparser from 'urlparser';

interface IState {
  url: string;
  jwt: string;
  overtime: boolean;
  trailId:string;
  userId:string;
  state:string;
}

interface IProps {
  userId:string;
  trailId:string;
  state:string;
}

interface IParams {
  jwt: string;
  isWeChat: string;
  weChatButtonUrl: string;
  logo: string;
}

class OverseasSharing extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      url: '',
      jwt: '',
      overtime: false,
      trailId:'',
      userId:'',
      state:''
    };
  }

  async componentDidMount() {
    await this.size();

    this.setState(
      {
        trailId:this.props.trailId,
        userId:this.props.userId
      },async ()=>{
        let data = await api.fackbookLink(this.state.trailId,this.state.userId);
        if (data) {
          await this.setState({
            url: data.body.url
          });
        }
      });
  }

  size = (): void => {
    let _html = document.getElementsByTagName('html')[0];
    let view_width = document.getElementsByTagName('html')[0].getBoundingClientRect().width;
    view_width > 1650 ? _html.style.fontSize = 1650 / 165 + 'px' : _html.style.fontSize = view_width / 1650 * 10 + 'px';
  };
  turn = (link: string): void => {
    if (link) {
      window.location.href = link;
    }
  };
  fackbook = () => {
    if (this.state.url) {
      window.open(this.state.url);
    }
  };

  render() {
    const { overtime } = this.state;
    return (
      <div className={'overseas-share-wrap'}>
        <div className={'overseas-share-head'}>
          <div className={'overseas-share-head-box'}>
            <div className={'overseas-share-head-nav'}>
              <img src={require('../../assets/overseas-share/logo_en_w.png')} alt=""/>
              <ul>
                {
                  navList.map(item => {
                    return <li className={item.title === 'FEATURES' ? 'overseas-share-head-nav-features' : ''}
                               key={item.title}
                               onClick={this.turn.bind(this, item.link)}>{item.title}{item.title === 'FEATURES' ?
                      <div className={'overseas-share-head-nav-features-bottom'}>
                        <ul>
                          {
                            featureList.map(item => {
                              return <li key={item.title} onClick={this.turn.bind(this, item.link)}>{item.title}</li>;
                            })
                          }
                        </ul>
                      </div> : null}</li>;
                  })
                }
              </ul>
            </div>
            <div className={'overseas-share-head-title'}>
              <h2>Share and get 7-day iSlide Trial Premium for FREE!</h2>
              <h3>Enjoy full features and resources of iSlide</h3>
            </div>
            <div className={'overseas-share-head-content'}>
              <div className={'overseas-share-head-content-left'}>
                <img src={require('../../assets/overseas-share/books.png')} alt=""/>
              </div>
              <div className={'overseas-share-head-content-right'}>
                <h2>Why iSlide Trial Premium?</h2>
                {
                  headContents.map(item => {
                    return <div key={item.title}>
                      <h3>
                        <svg color={'#fff'} width={'1.5rem'} aria-hidden="true" focusable="false" data-prefix="far"
                             data-icon="hand-point-right"
                             className="svg-inline--fa fa-hand-point-right fa-w-16" role="img"
                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                          <path fill="currentColor"
                                d="M428.8 137.6h-86.177a115.52 115.52 0 0 0 2.176-22.4c0-47.914-35.072-83.2-92-83.2-45.314 0-57.002 48.537-75.707 78.784-7.735 12.413-16.994 23.317-25.851 33.253l-.131.146-.129.148C135.662 161.807 127.764 168 120.8 168h-2.679c-5.747-4.952-13.536-8-22.12-8H32c-17.673 0-32 12.894-32 28.8v230.4C0 435.106 14.327 448 32 448h64c8.584 0 16.373-3.048 22.12-8h2.679c28.688 0 67.137 40 127.2 40h21.299c62.542 0 98.8-38.658 99.94-91.145 12.482-17.813 18.491-40.785 15.985-62.791A93.148 93.148 0 0 0 393.152 304H428.8c45.435 0 83.2-37.584 83.2-83.2 0-45.099-38.101-83.2-83.2-83.2zm0 118.4h-91.026c12.837 14.669 14.415 42.825-4.95 61.05 11.227 19.646 1.687 45.624-12.925 53.625 6.524 39.128-10.076 61.325-50.6 61.325H248c-45.491 0-77.21-35.913-120-39.676V215.571c25.239-2.964 42.966-21.222 59.075-39.596 11.275-12.65 21.725-25.3 30.799-39.875C232.355 112.712 244.006 80 252.8 80c23.375 0 44 8.8 44 35.2 0 35.2-26.4 53.075-26.4 70.4h158.4c18.425 0 35.2 16.5 35.2 35.2 0 18.975-16.225 35.2-35.2 35.2zM88 384c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"/>
                        </svg>
                        {item.title}</h3>
                      <p> {item.content}</p></div>;
                  })
                }
              </div>
            </div>
          </div>
        </div>
        <div className={'overseas-share-box'}>
          <h2>How to get 7-day iSlide Trial Premium?</h2>
          <div className={'overseas-share-box-content'}>
            <p><img src={require('../../assets/overseas-share/mail_icon.svg')} alt=""/><span>Simply click the button below to share iSlide on your Facebook.</span>
            </p>
            <p><img src={require('../../assets/overseas-share/clock_icon.svg')} alt=""/><span>Once done, your current iSlide account will be automatically upgraded to Trial Premium for 7 days.</span>
            </p>
            <p><img src={require('../../assets/overseas-share/hat_icon.svg')} alt=""/><span>Log out and log in again to iSlide add-in, to enjoy your trial Premium membership.</span>
            </p>
          </div>
          <div className={overtime?'overseas-share-box-disable-button':'overseas-share-box-button'}>
            <button disabled={overtime} onClick={this.fackbook}>Share on <img
              src={require('../../assets/overseas-share/facebook_icon.svg')}
              alt=""/></button>
          </div>
          <p className={'overseas-share-box-tip'}>*One user can get the 7-day iSlide trial Premium only once. However,
            we will appreciate if you want to share iSlide on your Facebook again.</p>
        </div>

      </div>
    );
  }
}

export default OverseasSharing;

const navList = [
  {
    title: 'HOME',
    link: 'https://en.islide.cc/'
  },
  {
    title: 'DOWNLOAD',
    link: 'https://en.islide.cc/download'
  },
  {
    title: 'FEATURES',
    link: ''
  },
  {
    title: 'ABOUT US',
    link: 'https://en.islide.cc/about-us'
  },
  {
    title: '中文',
    link: 'https://www.islide.cc/'
  }
];
const featureList = [
  {
    title: 'Standard Specification',
    link: 'https://en.islide.cc/standard-specification'
  },
  {
    title: 'Design Layout',
    link: 'https://en.islide.cc/design-layout'
  },
  {
    title: 'Theme Library',
    link: 'https://en.islide.cc/theme-library'
  },
  {
    title: 'Smart Diagram',
    link: 'https://en.islide.cc/smart-diagram-library'
  },
  {
    title: 'Diagram Library',
    link: 'https://en.islide.cc/diagram-library'
  },
  {
    title: 'Icon library',
    link: 'https://en.islide.cc/icon-library'
  },
  {
    title: 'Join Images',
    link: 'https://en.islide.cc/join-images'
  }
];
const headContents = [
  {
    title: 'Full Library Resources Access',
    content: 'Access and choose from 200k+ (free and Premium) presentation resources.'
  },
  {
    title: 'Massive daily Resource Downloads',
    content: 'Unlimited free resource downloads & up to 100 Premium resource downloads per day.'
  },
  {
    title: 'Download History',
    content: 'Browse and re-use all the resources you have downloaded before.'
  }
];
